// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TipBox = require("../../../uikit/atoms/TipBox/TipBox.bs.js");
let ViewStack = require("../../common/ViewStack.bs.js");
let JsxRuntime = require("react/jsx-runtime");

let streetAddress = JsxRuntime.jsx(TipBox.make, {
  title: "Street address",
  children: JsxRuntime.jsx("p", {
    children: `You must enter an exact street address for matching purposes. If you don‘t want the street
    address displayed to others, check “Hide address from others”.`
  })
});

let price = JsxRuntime.jsx(TipBox.make, {
  title: "Price",
  children: JsxRuntime.jsx("p", {
    children: `Enter the asking price for the property. If you don't have an exact price yet, check the box to specify a range.`
  })
});

let priceRange = JsxRuntime.jsx(TipBox.make, {
  title: "Price range",
  children: JsxRuntime.jsx("p", {
    children: "A tighter range will yield better results."
  })
});

function TipBoxes$PropertyWizard$MlsTimingWithComingSoon(props) {
  return JsxRuntime.jsx(TipBox.make, {
    title: "MLS timing",
    children: JsxRuntime.jsxs(ViewStack.make, {
      space: {
        NAME: "px",
        VAL: "p20"
      },
      children: [
        JsxRuntime.jsx("p", {
          children: `Let other agents know whether this property will be going into the MLS within the next month. `
        }),
        props.offMlsConfigurable ? null : JsxRuntime.jsx("p", {
            children: "If the property will not be on the MLS at all within the next month, you must be willing to show and accept offers."
          }),
        JsxRuntime.jsx("p", {
          children: "If the property will be going on the MLS in the next month, select whether you will be adding it to the MLS as a Coming Soon first or adding as Active.\n      Then provide your best estimate of the planned date it will go Active. Accurate information helps other agents and their clients."
        })
      ]
    })
  });
}

let MlsTimingWithComingSoon = {
  make: TipBoxes$PropertyWizard$MlsTimingWithComingSoon
};

let headline = JsxRuntime.jsx(TipBox.make, {
  title: "Headline",
  children: JsxRuntime.jsxs(ViewStack.make, {
    space: {
      NAME: "px",
      VAL: "p20"
    },
    children: [
      JsxRuntime.jsx("p", {
        children: "Summarize the most compelling aspects of the property."
      }),
      JsxRuntime.jsx("p", {
        children: "The headline is for the broadcast email about this property, so it cannot be edited later."
      })
    ]
  })
});

let tanMessage = JsxRuntime.jsx(TipBox.make, {
  title: "Message for TAN colleagues",
  children: JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: JsxRuntime.jsx("p", {
      children: "Use this field to send a message to other TAN members that is separate from the property description. This message is not shared with clients."
    })
  })
});

let PropertyWizard = {
  streetAddress: streetAddress,
  price: price,
  priceRange: priceRange,
  MlsTimingWithComingSoon: MlsTimingWithComingSoon,
  headline: headline,
  tanMessage: tanMessage
};

let TipBox$1;

exports.TipBox = TipBox$1;
exports.PropertyWizard = PropertyWizard;
/* streetAddress Not a pure module */
